// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".twig-profile{font-size:16px;line-height:25px}.twig-profile input,.twig-profile label,.twig-profile select{display:block}.twig-profile__form-part{padding:10px 0}h3+.twig-profile__form-part{padding:0 0 10px}.twig-profile--light{--text-color:#000;--link-color:#00f;--alert-color:#a00;--warning-color:#b33000;--muted-color:#666}.twig-profile--dark{--text-color:#fff;--link-color:#0ff;--alert-color:#f88;--warning-color:#ff4;--muted-color:#bbb}", ""]);
// Exports
module.exports = exports;
